import { BasicModel } from "../basic/model/BasicModel";
import { CampaignVars } from "../marketing/google/CampaignVars";
import { TimezoneUtil } from "../utils/TimezoneUtil";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";
import { BasicTrackingEvent } from "./BasicTrackingEvent";

// TODO @HTML5 HTML-3765  this event was actually sent via variables...  make sure it works fine when sent via POST json
export class ConnectionTrackingEvent extends BasicTrackingEvent {
    public cv: CampaignVars;
    public roundTrip: string;
    public downloadRate: number;
    public accountId: string;
    public playerID: number;
    /** Defines the track delay time for the second track time in seconds **/
    public delay: number;
    /** Indicates if the client is connected via socket (0) or http (1) **/
    public bluebox: number;

    // special mobile parameters
    public deviceId: number;
    public connectionType: string;
    public storeId: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.Connection.Event {
        const vars: trackingEvents.Connection.Event = {
            accountHash: this.accountId,
            bluebox: this.bluebox,
            clientTimeZone: TimezoneUtil.getTrackingTimezone(),
            conTime: BasicModel.smartfoxClient.connectionTime,
            delay: this.delay,
            downloadrate: this.downloadRate,
            eventId: trackingEvents.Connection.ID,
            event_mapping_version: 2,
            playerId: 0,
            roundTime: parseInt(this.roundTrip),

            // gamestate: this.gameState,
            referrer: this.referrer,

            // sessionId: this.sessionId,
            // websiteId: this.websiteId,
            deviceId: this.deviceId,
            // storeId: this.storeID,
            connectionType: this.connectionType,
            // previousGameState: this.previousGameState,
            // sessionLengthMs: this.sessionLengthMs,
        };

        if (this.cv && this.cv.isValid) {
            vars.partner_id = parseInt(this.cv.partnerId);
            vars.creative_id = parseInt(this.cv.creative);
            vars.placement = this.cv.placement;
            vars.keyword = this.cv.keyword;
            vars.network = this.cv.network;
            vars.landing_page = parseInt(this.cv.lp);
            vars.channel_id = this.cv.channelId;
            vars.traffic_source_id = this.cv.trafficSource;
            vars.advertiser_id = parseInt(this.cv.aid);
            vars.campaign_key = parseInt(this.cv.camp);
            vars.adgroup_key = parseInt(this.cv.adgr);
            vars.match_type = this.cv.matchtype;
        }

        return vars;
    }

}
